/**
 * VERSIONE LIBRERIA 3
 */
var RenderHasmany = Render.extend({
    type : 'hasmany',
    classData : 'hasmany',
    classTemplate : 'hasmany',
    hasManyModelName : null,
    hasManyModelRelativeName : null,
    _views : [],
    jsonData : null,
    limit : null,
    template : null,
    separator : null,
    fields : [],
    metadata : {},
    itemEditTemplate : null,
    itemViewTemplate : null,
    editTemplate : null,
    viewTemplate : null,
    init: function (key,config) {
        this._super(key,config);
    },

    _renderView : function(jQe) {
        var self = this;
        //log.info("RenderHasmany view ", self.data);
        if (self.value && self.value.length > 0) {
            var items = [];
            var numItems = self.limit?(self.limit<self.value.length)?self.limit:self.value.length:self.value.length;

            var tpl = '#' + self.prefixTemplateClass + '_' + self.type + '_view_items_tpl';

            if (self.template) {
                tpl = self.template
                for (var i=0;i<numItems;i++) {
                    items.push(self.value[i]);
                }
            } else {
                var separator = self.separator?self.separator:" ";
                for (var i=0;i<numItems;i++) {
                    var label = "";
                    //console.log('datai',self.value[i]);
                    for (var fi in self.fields) {
                        var field = self.fields[fi];
                        label+= self.value[i][field];
                        if (fi < self.fields.length-1)
                            label+= separator;
                    }
                    items.push({label:label});
                }

            }

            var tplData = {
                items : items
            }
            //console.log("ddddddd",tplData,tpl);
            $.renderTemplate($(tpl),jQe.find('[data-render_list]'),tplData);
        } else {
            jQe.find('[data-button_upload]').addClass('disabled');
        }
    },

    _finalizeView : function() {

    },

    _renderEdit : function (jQe) {
        var self = this;
        jQe.find('[data-render_list]').attr('data-render_list',self.key);
        var exists = self.key + "_exists";
        $('<input>').attr({
            type: 'hidden',
            name: exists,
            value : 1
        }).appendTo(jQe);
        return ;
    },



    _finalizeEdit : function () {
        var self = this;

        log.debug("finalize ",self.key," modelName " + self.metadata.modelRelativeName,$(self.container).find('[data-hasmany_container="'+ self.metadata.modelRelativeName+'"]').length);
        // renderizzo i valori gia' presenti

        var html = "";
        var _tmp = function () {

            for (var i in self.value) {
                var item = self.value[i];
                self.renderNewItem($(self.container),item);
            }


            $(self.container).find('[data-hasmany_title]').html($.translate('model-'+Utility.snakeCase(self.metadata.modelRelativeName),2));
            //jQe.find('[data-hasmany_title_msg]').html($.translateRaw(self.parentView.modelName+'-'+self.key+'_msg'));
            //jQe.find('[data-button_add]').html($.translate('general-add') + " " + $.translate('model-'+self.hasManyModelRelativeName));

            //jQe.find('[data-render_list="' + self.key + '"]').html(html);
            $(self.container).find('[data-button_add]').html($.translate('general-add') + " " + $.translate('model-'+Utility.snakeCase(self.metadata.modelRelativeName)) );

            self._bindDeleteEvents();
            $(self.container).find('[data-render_id="'+ self.key+'"]').find('[data-button_add]').click(function () {
                self.renderNewItem($(self.container));
                //console.log('HTML has many',self.container,'[data-render_id="'+ self.key+'"]','[data-hasmany_container="' + self.key + '"]');
                //$(self.container).find('[data-render_id="'+ self.key+'"]').find('[data-render_list="' + self.key + '"]').append(html);
                self._bindDeleteEvents();
            });
            $(self.container).find(".sort_class").sortable({
                handle: '.button-move',
            });
        }
        if (!self.jsonData) {
            self.getJsonData(function (json) {
                self.jsonData = json;
                _tmp();
            })

        } else {
            _tmp();
        }

    },
    _bindDeleteEvents : function () {
        var self = this;
        $(self.container).find('[data-button_delete]').unbind('click');
        $(self.container).find('[data-button_delete]').click(function () {
            var index = $(this).closest("li").index();
            var vIndex = $(this).closest("li").find('[data-view_index]').data('view_index');
            log.debug("found index ",index,'viewindex',vIndex);
            //$.messageDialog("index " + index);
            //var obj = $(self.container).find('[data-hasmany_container="'+self.hasManyModelName + '"]')
            self.deleteHasManyItem(self.hasManyModelRelativeName, index,vIndex);
        });
    },
    renderNewItem : function (jQe,values) {
        var self = this;
        var status = 'updated';
        var fields = [];
        if (!values) {
            status = 'new';
            // prendo i valori di default dei metadata;
            //var fields = self.metadata.fields;
            fields = Object.keys(self.jsonData.result);
            values = {};
            for (var i in self.jsonData.result) {
                values[i] = self.jsonData.result[i]//fields[i].column_default;
            }
        }
        values.status = status;
        var viewModelName = self.key;//self.metadata.modelRelativeName;
        // controllo che non abbia una configurazione privata

        var viewConfig = self.modelConf? self.modelConf : Facade.getConf(self.metadata.modelRelativeName,'edit')  //new EditConfs();
        if ($.inArray('status',viewConfig.fields) < 0)
            viewConfig.fields.push('status');
        //viewConfig.fields.push('status');// = ['status','id'];
        if ($.inArray('id',viewConfig.fields) < 0) {
            viewConfig.fields.push('id');
        }

        viewConfig.fields_type.status = {type:'input',inputType:'hidden'};
        //viewConfig.fields_type.id = {type:'input',inputType:'hidden'};
        viewConfig.langs = self.langs;
        //console.log('HASMANY config',viewConfig,viewConfig.fields);

        var tmpContainer = null;
        if (self.itemEditTemplate) {
            tmpContainer = $.createDynamicContainer(self.itemEditTemplate);
        } else {
            tmpContainer = $.createDynamicContainer('#'+self.prefixTemplateClass + "_hasmany_item_tpl");
        }



        tmpContainer.find('[data-hasmany_item]').attr('data-hasmany_item',tmpContainer.attr('id'));
        jQe.find('[data-render_list="' + self.key + '"]').append(tmpContainer.html());

        viewConfig.container = '[data-hasmany_item="'+ tmpContainer.attr('id') +'"]';

        tmpContainer.remove();
        /*
         var viewData = {
         value : values,
         translations : {},
         metadata : self.metadata,
         resultParams : self.resultParams
         };
         */
        var viewData = {
            value : values,
            translations : self.jsonData.translations,
            metadata : self.jsonData.metadata,
            resultParams : self.jsonData.resultParams
        };

        var view = new ViewEdit(viewModelName,viewConfig,viewData);
        view.hasManyIndex = self._views.length;
        view.isHasMany = true;
        self._views.push(view);
        $(viewConfig.container).attr('data-view_index',view.hasManyIndex);
        view.render();
        console.log('VIEW: ',view);

    },
    deleteHasManyItem : function (modelName,index,viewIndex) {
        var self = this;
        //var modelName = Utility.camelCase(self.model.resultParams[self.key].modelName);

        var hasManyContainer = $(self.container).find('[data-render_id="'+ self.key+'"]');
        var status = hasManyContainer.find('input[name="' + self.key + '-status[' + viewIndex +']"]').val();
        log.debug("deleteHasManyItem index" , viewIndex , " status ", status);
        //hasManyContainer.find()

        if (status == "new") {
            hasManyContainer.find('[data-hasmany_item_structure]:eq('+index+')').remove();
        } else {
            hasManyContainer.find('input[name="' + self.key + '-status[' + viewIndex +']"]').val('deleted');

            //hasManyContainer.find('input[name="' + self.key + '-status[]"]:eq('+index+')').attr("value",'deleted');
            hasManyContainer.find('[data-hasmany_item_structure]:eq('+index+')').addClass("hide");

        }
    },
    // ridefinire questa funzione pre prendere i dati giusti per il riempimento della form
    // hasmany
    getJsonData : function (callback) {
        var jsonData = [];
        return callback(jsonData);
    }
});